import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primereact/resources/themes/lara-light-purple/theme.css';
import { ReportHeader } from '../../header/report-header';
import { ProfessorCourseFeedbacksSideBarFilter } from './side-bar-filter/professor-course-feedbacks-side-bar-filter';
import { getProfessorCourseFeedbacksOperation } from './operations/get-professor-course-feedbacks-operation';
import { ProfessorCourseFeedbacksFilterType } from './side-bar-filter/professor-course-feedbacks-filter.type';
import { CourseStatus } from '../../../../api/types/programs/course/course-status';

export interface ProfessorCourseFeedbackRow {
  branchName: string;
  courseName: string;
  courseStatus: CourseStatus;
  courseStartDate: string;
  pollName: string;
  professorName: string;
  professorId: number;
}

export const ProfessorCourseFeedbacks = () => {
  const [reportData, setReportData] = useState<ProfessorCourseFeedbackRow[]>(
    [],
  );
  const [loading, setLoading] = useState(false);

  const handleSearch = async (filters: ProfessorCourseFeedbacksFilterType) => {
    await getProfessorCourseFeedbacksOperation(
      filters,
      setReportData,
      setLoading,
    );
  };

  const courseStatusBodyTemplate = (rowData: ProfessorCourseFeedbackRow) => {
    return CourseStatus.getDisplayText(rowData.courseStatus);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <ReportHeader
        title="משובי הוראה למרצים"
        description="דו״ח זה מציג מידע על משובי הוראה למרצים בקורסים השונים. הדו״ח כולל פרטי הקורס, המרצה וסוג המשוב."
        metadata={[
          { label: 'מטרת הדו״ח', value: 'מעקב אחר משובי הוראה' },
          { label: 'תדירות עדכון', value: 'יומי' },
        ]}
        category="education"
      />

      <div style={{ display: 'flex', gap: '20px' }}>
        <div
          style={{
            height: 'calc(100vh - 230px)',
            minHeight: '100%',
            width: '300px',
            minWidth: '250px',
          }}
        >
          <ProfessorCourseFeedbacksSideBarFilter onSearch={handleSearch} />
        </div>

        {/* Table Section */}
        <div style={{ flex: 1 }}>
          <DataTable
            value={reportData}
            rows={10}
            rowHover
            rowClassName={() => 'cursor-pointer'}
            rowsPerPageOptions={[5, 10, 25, 50]}
            emptyMessage={
              <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
            }
            dataKey="professorId"
            scrollable
            scrollHeight="calc(100vh - 300px)"
            loading={loading}
            tableStyle={{
              direction: 'rtl',
            }}
            className="professor-course-feedbacks-table"
          >
            <Column
              field="branchName"
              header="שלוחה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="courseName"
              header="קורס טיפוסי"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="courseStatus"
              header="סטטוס קורס"
              body={courseStatusBodyTemplate}
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="courseStartDate"
              header="תאריך התחלה של קורס"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="pollName"
              header="סוג משוב טיפוסי"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="professorName"
              header="מרצה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
          </DataTable>
        </div>
      </div>
    </div>
  );
};
